import { EMPTY_OBJECT } from '../../utils/constants'

export const filtersInitialState = {
  isOpenOutside: false,
  isOpenInside: false,
  propsModal: EMPTY_OBJECT,
  activeFilterItem: null,
  filterButtonCount: 0
}

export const filtersReducer = (state, { type, payload }) => {
  switch (type) {
    case 'OPEN_OUTSIDE':
      return { ...state, isOpenOutside: true, propsModal: payload }
    case 'CLOSE_OUTSIDE':
      return { ...state, isOpenOutside: false, propsModal: null }
    case 'SET_ACTIVE_INSIDE_FILTER':
      return { ...state, activeFilterItem: payload }
    case 'REMOVE_ACTIVE_INSIDE_FILTER':
      return { ...state, activeFilterItem: null }
    case 'SET_ACTIVE_FILTERS_COUNT':
      return { ...state, filterButtonCount: payload }
    default:
      throw new Error('Wrong action type')
  }
}

export const showInitialState = {
  modalOn: false,
  filterShow: false
}

export const showReducer = (state, { type, payload }) => {
  switch (type) {
    case 'SHOW':
      return { ...state, modalOn: true, filterShow: true }
    case 'HIDE':
      return { ...state, modalOn: false, filterShow: false }
    case 'TOGGLE_FILTER':
      return { ...state, filterShow: payload }
    case 'SHOW_FILTER':
      return { ...state, filterShow: true }
    case 'HIDE_FILTER':
      return { ...state, filterShow: false }
    default:
      throw new Error('Wrong action type')
  }
}

export const filterInitialState = {
  itemSelected: EMPTY_OBJECT,
  activeFilter: false
}

export const filterReducer = (state, { type, payload }) => {
  switch (type) {
    case 'SELECT_ITEM':
      return { ...state, activeFilter: true, itemSelected: { ...payload } }
    default:
      throw new Error('Wrong action type')
  }
}

export const asyncFilterInitialState = {
  asyncData: [],
  loadingAsyncData: false
}

export const asyncFilterReducer = (state, { type, payload }) => {
  switch (type) {
    case 'FETCHING':
      return { ...state, asyncData: [], loadingAsyncData: true }
    case 'READY':
      return { ...state, asyncData: payload, loadingAsyncData: false }
    default:
      throw new Error('Wrong action type')
  }
}
